import {Component, computed, inject, input, OnInit, output} from '@angular/core';
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {Location} from "@angular/common";
import {Router} from "@angular/router";
import {RouterExtService} from '../../services/router-ext.service';

@Component({
  selector: 'app-header',
  imports: [
    MatIcon,
    MatButton,
    MatIconButton
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  private readonly location: Location = inject(Location);
  private readonly router: Router = inject(Router);
  private readonly routerExtService: RouterExtService = inject(RouterExtService);

  title = input<string>();
  description = input<string>();
  border = input<boolean>(true);
  wrap = input<boolean>(false);
  uppercase = input<boolean>(false);
  mainGap = input<boolean>(true);

  enableGoBack = input<boolean>(false);
  locationBack = input<boolean>(false);
  routerOnePathBack = input<boolean>(false);
  enableSearch = input<boolean>(false);
  enableAddBtn = input<boolean>(false);
  hasCustomTitle = input<boolean>(false);

  goBackLabel = input<string>('Back');
  goBackAriaLabel = input<string>('Go back');
  showGoBackLabel = input<boolean>(false);
  goBackIcon = input<string>('arrow_back');

  addBtnLabel = input<string>('Add');
  addBtnIcon = input<string>('add');
  addBtnAriaLabel = input<string>('Add Item');

  className = computed(() =>
    `hero-navbar
    ${this.border() ? 'border' : ''}
    ${this.mainGap() ? 'maingap' : ''}
    ${this.wrap() ? 'wrap' : ''}
    ${this.enableSearch() ? 'has-search' : ''}
    ${this.enableGoBack() ? 'has-back' : ''}`
  );

  previousUrl?: string;

  ngOnInit(): void {
    this.previousUrl = this.routerExtService.getPreviousUrl();
  }

  goBack = output<void>();
  addBtnClick = output<void>();

  showHeading = computed(() => !!(this.title() || this.description() || this.hasCustomTitle()));

  onGoBackHandler(): void {
    if (this.locationBack()) {
      if (this.previousUrl) {
        this.router.navigateByUrl(this.previousUrl);
      } else {
        this.location.back();
      }
    }
    if (this.routerOnePathBack()) {
      const currentUrl = this.router.url;
      const [pathWithQuery] = currentUrl.split('#');
      const [path, queryString] = pathWithQuery.split('?');
      const segments = path.split('/').filter(Boolean);
      if (segments.length <= 1) {
        this.router.navigateByUrl('/');
        return;
      }
      const parentPath = '/' + segments.slice(0, -1).join('/');
      this.router.navigateByUrl(
        queryString ? `${parentPath}?${queryString}` : parentPath
      );
      return;
    } else {
      this.goBack.emit();
    }
  }
}
